{
    "aboutbanner.label": "{siloName} Räume sind anders",
    "account.admin_email_notifications": "E-Mail-Benachrichtigungen für Admins",
    "account.admin_language": "Bevorzugte Sprache",
    "account.admin_language_no_language": "Keine Sprache",
    "account.admin_moderation_dash_settings": "Einstellungen des Moderations-Dashboards",
    "account.title": "Konto",
    "account_delete.confirm_description": "Das Löschen Ihres Profils kann nicht rückgängig gemacht werden. Alle mit Ihrem Profil verbundenen Daten und Aktivitäten können bis zu 72 Stunden für die Entfernung benötigen.",
    "account_delete.confirm_heading": "Sind Sie sicher, dass Sie Ihre Profildaten löschen möchten?",
    "account_delete.description": "Auf Anfrage werden der Diskussionsverlauf Ihres Kontos und Ihre Beteiligung an Diskussionen im Rahmen der Anfrage gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "account_delete.heading": "Meine Daten löschen",
    "account_request_data.heading": "Meine Daten anfordern",
    "account_request_data.instructions": "Senden Sie eine E-Mail an [privacy@newpublic.org](mailto:privacy@newpublic.org), um eine Kopie Ihrer mit diesem Diskussionsbereich verbundenen Daten anzufordern. Die Bearbeitung Ihrer Anfrage kann bis zu 30 Tage dauern.",
    "account_revoke_permissions.confirm_heading": "Admin-Berechtigungen von {identifier} widerrufen?",
    "account_revoke_permissions.confirm_text": "{identifier} wird keine Administratorrechte mehr haben.",
    "account_revoke_permissions.revoke_button": "Berechtigungen widerrufen",
    "action.block": "Blockieren",
    "action.cancel": "Abbrechen",
    "action.create_new_voting": "Neue Abstimmung erstellen",
    "action.edit": "Bearbeiten",
    "action.pinned": "Angeheftet",
    "action.post": "Posten",
    "action.reply_to_user": "Antwort an {userName}...",
    "action.report": "Melden",
    "action.save": "Speichern",
    "action.unblock": "Entsperren",
    "admin.category_analysis_heading": "Analyse",
    "admin.category_developer_tools_heading": "Entwicklerwerkzeuge",
    "admin.category_editorial_heading": "Redaktionell",
    "admin.category_moderation_heading": "Moderation",
    "admin.category_owner_tools_heading": "Eigentümerwerkzeuge",
    "admin.category_starred_heading": "Markiert",
    "admin.window_title": "Admin-Dashboard",
    "admin_mod_link.admin_users_description": "Verwaltung der Benutzerrechte.",
    "admin_mod_link.editorial_dashboard_description": "Verwalten Sie Bereiche und mehr.",
    "admin_mod_link.editorial_dashboard_label": "Redaktioneller Dashboard",
    "admin_mod_link.moderation_dashboard_description": "Moderieren Sie Diskussionen im überarbeiteten Dashboard.",
    "admin_mod_link.ranking_eval_description": "Bewerten Sie verschiedene Ranking-Algorithmen anhand realer Gespräche.",
    "admin_mod_link.ranking_eval_label": "Ranking-Bewertung",
    "admin_mod_link.settings_description": "Verwalten Sie Organisationseinstellungen und Funktionen.",
    "admin_mod_link.settings_label": "Einstellungen",
    "admin_mod_link.storybook_description": "View PSI components in Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Admins hinzufügen",
    "admin_users.add_new_admins_label": "Neue Administratoren hinzufügen",
    "admin_users.adding_admins_message": "Admins werden hinzugefügt...",
    "admin_users.emails_placeholder": "E-Mail-Adressen der hinzuzufügenden Benutzer",
    "admin_users.heading": "Admin-Benutzer",
    "admin_users.loading_message": "Administratoren werden geladen...",
    "admin_users.updating_roles_message": "Rollen werden aktualisiert...",
    "admins.actions.edit": "Bearbeiten",
    "admins.actions.revoke": "Berechtigungen widerrufen",
    "admins.actions.revoke-failed": "Fehler beim Widerrufen der Admin-Berechtigungen von {userIdentity}",
    "admins.actions.revoked": "{userIdentity} hat keine Admin-Berechtigungen mehr",
    "admins.all_admins": "Alle",
    "admins.column_actions": "Aktionen",
    "admins.column_name": "Name",
    "admins.column_posts": "Beiträge",
    "admins.column_roles": "Interne Berechtigungen",
    "admins.column_title": "Titel",
    "admins.error": "Konnte die Admin-Tabelle nicht abrufen",
    "admins.tab_label": "Mitarbeiterprofile",
    "admins.table.search": "Suchen...",
    "admins.title": "Mitarbeiterprofile",
    "agree": "Zustimmen",
    "ai-helper.bullet": "👉 {tipText}",
    "ai-helper.rephrase_message": "Überlegen Sie, Ihre Nachricht umzuformulieren, um ein breiteres Publikum zu erreichen und bedeutungsvollere Diskussionen anzuregen.",
    "ai-helper.suggestions_title": "Vorschläge",
    "ai-helper.tips_title": "Versuchen Sie, diese Tipps zu befolgen:",
    "aitag.ai_moderated": "Von KI moderiert",
    "appError.goHome": "Geh zurück",
    "appError.page_forbidden": "Ihr Konto kann nicht auf diese Seite zugreifen.",
    "appError.page_not_found": "Die Seite, die Sie suchen, existiert nicht.",
    "appError.page_unauthorized": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.",
    "article.admin_only_error": "Sie müssen sich als Administrator anmelden, um diesen Bildschirm ansehen zu können.",
    "article.login_button": "Anmelden",
    "article.no_teaser_error": "Kein Teaser definiert",
    "article.zdf_section": "ZDF-Abschnitt",
    "article_teaser_position.max_positions": "Maximal 2 Positionen erlaubt",
    "audience_input.community_guidelines_title": "Gemeinschaftsrichtlinien",
    "audience_input.composer_placeholder": "Dein Beitrag zum Thema...",
    "audience_input.your_reply_label": "Ihre Antwort",
    "audience_input_template.description": "Fragen, Testimonials und Geschichten von Nutzern sammeln. Dies erlaubt eine größere Bandbreite an Engagement.",
    "audience_input_template.label": "Zielgruppe",
    "blocklist.empty_list": "Die Blocklist ist leer",
    "blocklist.include_alternative_spellings": "Alternative Schreibweisen einbeziehen",
    "blocklist.no_results": "Keine Einträge entsprechen Ihrer Suche.",
    "blocklist.only_singular_term": "Nur singuläre Begriffe",
    "blocklist.single_term_not_deleted": "Der Blocklistenbegriff konnte nicht gelöscht werden",
    "blocklist.singular_term_tag": "Singulärer Begriff",
    "blocklist.term_adoption_description": "Wählen Sie aus, ob die Begriffe genau so übernommen werden sollen, wie Sie sie eingegeben haben, oder ob sie in erweiterter Form enthalten sein sollen.",
    "blocklist.term_required": "Bitte geben Sie einen Begriff ein",
    "blocklist.terms_may_not_be_longer_than": "Begriffe dürfen nicht länger als 150 Zeichen sein.",
    "blocklist.terms_not_added_duplicate": "Blocklistenbegriff existiert bereits: {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Blocklistenbegriff existiert bereits: {duplicateTerms}. Blocklistenbegriff konnte nicht hinzugefügt werden, bitte versuchen Sie es erneut: {refusedTerms}",
    "blocklist.terms_not_added_refused": "Blocklistenbegriff konnte nicht hinzugefügt werden, bitte versuchen Sie es erneut: {refusedTerms}",
    "blocklist.terms_not_deleted": "{failedCount} von {totalCount} Blocklistenbegriffen konnten nicht gelöscht werden",
    "blocklist.too_long_terms_removed": "Begriffe, die länger als 150 Zeichen sind, wurden entfernt.",
    "button.react": "Reagieren",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "deaktiviert",
    "button.react_button_selected": "Ausgewählt",
    "button.reacted": "Reagiert",
    "byline.deleted_user": "Gelöschter Benutzer",
    "byline.edited": "Bearbeitet",
    "byline.post_id": "ID:",
    "channel_settings.title": "Kanaleinstellungen",
    "channels.add_channel_button": "Kanal hinzufügen",
    "channels.channels_label": "Kanäle",
    "channels.default_channel_label": "Standardkanal",
    "channels.delete_tooltip": "Sie können den Standardkanal oder Kanäle, die verwendet werden, nicht löschen",
    "channels.image_preview": "Bildvorschau",
    "channels.manage_channels_heading": "Kanäle verwalten",
    "channels.no_channels_available": "Keine Kanäle verfügbar",
    "channels.no_channels_available_info": "Erstellen und verwalten Sie Kanäle im Moderations-Dashboard.",
    "channels.not_channel_member_warning": "Sie sind kein Kanalmitglied, dadurch sind bestimmte Funktionen deaktiviert!",
    "channels.select_channel": "Kanal auswählen",
    "channels.title": "Kanal",
    "close_conversation.closed_message": "Diese Unterhaltung ist nun beendet.",
    "comment.cancel_button": "Abbrechen",
    "comment.confirm_leave_description": "Die Änderungen, die Sie vorgenommen haben, werden nicht gespeichert.",
    "comment.confirm_leave_heading": "Sind Sie sicher, dass Sie die Seite verlassen möchten?",
    "comment.delete_modal_heading": "Sind Sie sicher, dass Sie diesen Beitrag löschen möchten?",
    "comment.delete_modal_warning": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "comment.edit_button": "Bearbeiten",
    "comment.post_button": "Posten",
    "comment.posting": "Wird veröffentlicht...",
    "comment.public_comment_subtitle": "Öffentlicher Kommentar",
    "comment.read_more_button": "Mehr lesen",
    "comment.reply_button": "Antworten",
    "comment.report_button": "Melden",
    "comment.show_less": "Weniger anzeigen",
    "comment.show_more_replies_plural": "{count} weitere Antworten anzeigen",
    "comment.show_more_reply_singular": "{count} weitere Antwort anzeigen",
    "comment.show_original": "Original anzeigen ({language})",
    "comment.show_translation": "Übersetzung anzeigen ({language})",
    "comment.update_button": "Posten",
    "comment.updating": "Aktualisierung...",
    "comment.your_reply_label": "Ihre Antwort",
    "comment_feedback.only_visible_to_you": "Nur für dich sichtbar",
    "comment_slider.change_vote_button": "Bearbeite deinen Beitrag",
    "comment_slider.community_guidelines_title": "Gemeinschaftsrichtlinien",
    "comment_slider.its_complicated": "Es ist kompliziert",
    "comment_slider.no_with_reservations": "Nein, aber mit Vorbehalten",
    "comment_slider.public_response": "Öffentlicher Beitrag",
    "comment_slider.recording_vote": "Abstimmung wird aufgezeichnet...",
    "comment_slider.response": "Beitrag",
    "comment_slider.responses": "Beiträge",
    "comment_slider.share_thoughts": "Dein Beitrag zum Thema",
    "comment_slider.skip_change_vote": "Überspringen und Stimme ändern",
    "comment_slider.skip_submit_vote": "Überspringen und Stimme abgeben",
    "comment_slider.slide_to_respond": "Zum Antworten schieben:",
    "comment_slider.strongly_no": "Stark nein",
    "comment_slider.strongly_yes": "Stark ja",
    "comment_slider.update_response": "Bearbeite deinen Beitrag",
    "comment_slider.yes_with_reservations": "Ja, aber mit Vorbehalten",
    "comment_slider.your_reply_label": "Ihre Antwort",
    "comment_slider_editable_positions.heading": "Kommentar-Schieberegler anpassen",
    "comment_slider_template.description": "Bitten Sie die Benutzer, Ihre Frage anhand eines Spektrums zu beantworten (z. B. „Überhaupt nicht“ bis „Überhaupt ja“).",
    "comment_slider_template.label": "Kommentar-Slider",
    "common.access_denied": "Zugriff verweigert",
    "common.are": "sind",
    "common.cancel": "Abbrechen",
    "common.download": "Herunterladen",
    "common.is": "ist",
    "common.loading": "Lädt...",
    "common.select": "Auswählen",
    "community_guidelines.aria_popup_label": "{label} (Pop-up-Fenster)",
    "community_guidelines.category_engage_respectfully": "Respektvoll handeln",
    "community_guidelines.category_no_disruptive_behavior": "Kein störendes Verhalten",
    "community_guidelines.category_no_harmful_content": "Keine schädlichen Inhalte",
    "community_guidelines.category_support_claims": "Untermauern Sie Ihre Behauptungen",
    "community_guidelines.constructive_content_explanation": "**Kommentare, die konstruktiver sein könnten**, können Vorschläge erhalten, wie sie besser mit unseren Community-Normen übereinstimmen können. Sie haben die Möglichkeit, Ihren Kommentar zu überarbeiten oder ihn wie geschrieben zu veröffentlichen. Kommentare, die nach Erhalt von Vorschlägen ohne Überarbeitung veröffentlicht werden, können im Feed niedriger eingestuft werden, um konstruktivere Beiträge zu priorisieren.",
    "community_guidelines.guidelines_intro": "Unsere Community-Richtlinien sind:",
    "community_guidelines.harmful_content_explanation": "**Schädliche Inhalte**, die gegen unsere Community-Richtlinien verstoßen, werden vom Posten blockiert. Wenn diese Entscheidung von KI getroffen wurde, können Sie Ihren Beitrag zur Überprüfung an einen menschlichen Moderator weiterleiten.\n\n**Kommentare, die konstruktiver sein könnten**, können Vorschläge erhalten, wie sie besser mit unseren Community-Normen übereinstimmen. Sie haben die Möglichkeit, Ihren Kommentar zu überarbeiten oder wie geschrieben zu posten. Kommentare, die nach Erhalt von Vorschlägen ohne Überarbeitung gepostet werden, können im Feed niedriger eingestuft werden, um konstruktivere Beiträge zu priorisieren.",
    "community_guidelines.modal_heading": "Community-Richtlinien und Normen",
    "community_guidelines.modal_intro": "Wir bemühen uns, in diesem Raum echte, respektvolle und offene Gespräche zu inspirieren. Jeder ist willkommen, seine Erfahrungen zu teilen; Perspektiven auszutauschen und zu debattieren; und Fragen im Geiste von Freundlichkeit, Verbindung und Neugier zu stellen.",
    "community_guidelines.moderation_explanation": "Dieser Raum ist für durchdachtere Gespräche als typische Internetkommentare konzipiert. Unser Moderationsprozess hilft, diesen Standard aufrechtzuerhalten, während er Ihre Stimme und Perspektive respektiert.",
    "community_guidelines.norms_intro": "Unsere Community-Normen sind:",
    "community_guidelines.rule_avoid_derogatory_labels": "Vermeiden Sie abwertende Bezeichnungen",
    "community_guidelines.rule_avoid_sarcasm": "Vermeiden Sie Sarkasmus und abweisende Antworten",
    "community_guidelines.rule_explain_constructively": "Erklären Sie Meinungsverschiedenheiten konstruktiv",
    "community_guidelines.rule_express_civility": "Drücken Sie Ihre Ideen höflich aus",
    "community_guidelines.rule_focus_on_ideas": "Konzentrieren Sie sich auf Ideen, nicht auf Charakterurteile",
    "community_guidelines.rule_no_illegal_content": "Keine illegalen Inhalte",
    "community_guidelines.rule_no_offtopic": "Keine themenfremden Beiträge",
    "community_guidelines.rule_no_spam": "Kein Spam oder kommerzielle Werbung",
    "community_guidelines.rule_no_violent_content": "Keine gewalttätigen Inhalte oder Aufrufe zu Schaden",
    "community_guidelines.rule_provide_sources": "Geben Sie Quellen für Tatsachenbehauptungen an",
    "community_guidelines.rule_respect_privacy": "Respektieren Sie die Privatsphäre anderer, teilen Sie keine persönlichen Informationen",
    "community_guidelines.title": "Gemeinschaftsrichtlinien",
    "community_guidelines.what_happens_heading": "Was passiert, wenn Ihr Beitrag gegen die Community-Richtlinien oder -Normen verstößt?",
    "context_entry_points.From": "Von",
    "context_entry_points.joined_from": "Beigetreten von",
    "conversation_helper.analyze_conversation": "Gespräch analysieren",
    "conversation_helper.checks_performed": "- **{count} Gesprächsanalyse(n)** durchgeführt",
    "conversation_helper.conversation_analysis": "Gesprächsanalyse",
    "conversation_helper.conversation_stats": "Gesprächsstatistiken",
    "conversation_helper.conversation_summary": "Gesprächszusammenfassung",
    "conversation_helper.current_guidance": "Aktueller Hinweis",
    "conversation_helper.dashboard": "Gesprächshelfer Dashboard",
    "conversation_helper.disagree": "Nicht zustimmen",
    "conversation_helper.explanation": "Erklärung",
    "conversation_helper.generate_new_guidance": "Neuen Hinweis generieren",
    "conversation_helper.generated_because": "Dieser Hinweis wurde generiert, weil...",
    "conversation_helper.guidance_messages_generated": "- **{count} Hinweis(e)** generiert",
    "conversation_helper.guidance_visible_to_everyone": "Dieser Hinweis ist für alle sichtbar.",
    "conversation_helper.hello_everyone": "Hallo zusammen!",
    "conversation_helper.help_history": "Hilfeverlauf",
    "conversation_helper.helpful": "Hilfreich",
    "conversation_helper.last_analysis_none": "- Letzte Gesprächsanalyse: **Keine**",
    "conversation_helper.last_analysis_time": "- Letzte Gesprächsanalyse: **{time}**",
    "conversation_helper.new_comments_since_analysis": "- **{count} neue(r) Kommentar(e)** seit der letzten Analyse",
    "conversation_helper.no_history": "Keine Historie verfügbar.",
    "conversation_helper.no_problems": "Keine Probleme gefunden.",
    "conversation_helper.problems_detected": "Probleme gefunden!",
    "conversation_helper.related_space": "Zugehörige Unterhaltung",
    "conversation_helper.result": "Ergebnis: ",
    "conversation_helper.thank_you": "Danke",
    "conversation_home.about_heading": "Über {brandName}",
    "conversation_home.brand_name": "der Public Spaces Incubator",
    "conversation_home.citizen_conversation": "Nehmen Sie an einem echten Gespräch teil",
    "conversation_home.citizen_conversation_description": "Teilen Sie Ihre Perspektive in einem Raum, der für nachdenklichen, konstruktiven Dialog gestaltet wurde.",
    "conversation_home.error_loading": "Fehler beim Laden der Unterhaltungen.",
    "conversation_home.focused_topics": "Tauchen Sie in die Themen ein, die Sie betreffen",
    "conversation_home.focused_topics_description": "Gespräche beginnen mit einer klaren Aufforderung oder Frage, die die Diskussion fokussiert und sinnvoll hält.",
    "conversation_home.hero_subtitle": "Nehmen Sie an der Diskussion mit unseren Journalisten und Menschen aus dem ganzen Land teil.",
    "conversation_home.hero_title": "Nachdenkliche Gespräche über Themen, die Ihnen wichtig sind",
    "conversation_home.latest_title": "Entdecken Sie die neuesten Gespräche",
    "conversation_home.no_conversations": "Noch keine Gespräche.",
    "conversation_home.with_experts": "Verbinden Sie sich direkt mit Experten und Journalisten",
    "conversation_home.with_experts_description": "Stellen Sie Fragen, gewinnen Sie tiefere Einblicke und treten Sie direkt mit glaubwürdigen Stimmen in Kontakt, die Sie schätzen.",
    "cta_button.loading": "Wird geladen",
    "dashboard.table.demo.pagination": "Räume (Seitenweise)",
    "dashboard.table.demo.users": "Räume",
    "date.days_abbrev": "{days} Tg.",
    "date.hours_abbrev": "{hours} Std.",
    "date.minutes_abbrev": "{minutes} Min.",
    "date.months_abbrev": "{months} M.",
    "date.now": "jetzt",
    "date.years_abbrev": "{years} J.",
    "deleted_post.author_deleted": "Der Autor hat diesen Beitrag gelöscht.",
    "deleted_post.deleting": "Wird gelöscht…",
    "deleted_post.you_deleted": "Sie haben diesen Beitrag gelöscht.",
    "demo.comment": "Kommentar",
    "demo.comments": "Kommentare",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "Nicht zustimmen",
    "demo.fwrd": "WEIT",
    "demo.load_video_element": "Video-Element laden",
    "demo.new_to_me": "Neu für mich",
    "demo.pause": "PAUS",
    "demo.play": "SPIE",
    "demo.prev": "ZURÜ",
    "demo.respect": "Respekt",
    "demo.thank_you": "Danke",
    "demo.tile_admin_users_description": "Verwaltung der Benutzerrechte.",
    "demo.tile_admin_users_label": "Admin-Benutzer",
    "developer_tools.email_testing": "E-Mail-Test",
    "developer_tools.email_testing_description": "Senden Sie eine Test-E-Mail an die E-Mail-Adresse Ihres Kontos.",
    "developer_tools.installed_versions": "Installierte Versionen",
    "developer_tools.key": "Schlüssel",
    "developer_tools.send_test_email": "Test-E-Mail senden",
    "developer_tools.sending": "Senden...",
    "developer_tools.test_email_sent": "Test-E-Mail erfolgreich über {provider} gesendet",
    "developer_tools.title": "Entwicklerwerkzeuge",
    "developer_tools.translation_queue": "Translation Queue",
    "developer_tools.translation_queue_description": "Process pending translation jobs for the current silo.",
    "developer_tools.translation_queue_done": "Verarbeitung der Übersetzungswarteschlange abgeschlossen",
    "developer_tools.translation_queue_locked": "Die Warteschlange ist gesperrt — ein anderer Prozess läuft bereits.",
    "developer_tools.translation_queue_process": "Process Queue",
    "developer_tools.translation_queue_processing": "Processing...",
    "developer_tools.translation_queue_result": "Verarbeitet: {processed}, Fehlgeschlagen: {failed}, Übersprungen: {skipped}",
    "developer_tools.translation_queue_stats": "Aufträge in der Warteschlange: {total} ({pending} ausstehend, {failed} fehlgeschlagen)",
    "developer_tools.unable_to_display": "Umgebungsvariablen können nicht angezeigt werden.",
    "developer_tools.value": "Wert",
    "developer_tools.version_client": "Client",
    "developer_tools.version_server": "Server",
    "developer_tools.version_unknown": "Unbekannt",
    "dialogue.recording_vote": "Stimme wird aufgezeichnet...",
    "dialogue.response_count": "{total} Antworten",
    "dialogue.response_plural": "{count} Antworten",
    "dialogue.response_singular": "{count} Antwort",
    "dialogue.share_your_thoughts": "Teile deine Gedanken...",
    "dialogue.skip_submit_vote": "Überspringen und Abstimmung abgeben",
    "dialogue.update_response": "Aktualisiere deine Antwort",
    "dialogue_editable_labels.heading": "Dialog anpassen",
    "dialogue_template.description": "Bitten Sie die Benutzer, Ihre Frage mit einem einfachen „Ja“ oder „Nein“ zu beantworten.",
    "dialogue_template.label": "Dialog",
    "disagree": "Nicht zustimmen",
    "editable_positions_widget.button_label": "Positionen bearbeiten",
    "editable_positions_widget.label": "Position #{position}",
    "editorial_dash.title": "Redaktioneller Dashboard",
    "editorial_experts.with-experts": "Mit redaktionellen Experten",
    "editorial_question.be_first": "Sei die erste Person, die ihre Gedanken teilt",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Beteilige Dich am Gespräch",
    "editorial_question.lets_talk": "Lasst uns reden",
    "editorial_question.response_singular": "Beitrag",
    "editorial_question.responses_plural": "Beiträge",
    "editorial_question.share_thoughts": "Dein Beitrag zum Thema",
    "error.api": "Etwas ist schiefgelaufen",
    "error.network": "Netzwerkfehler - Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "features.srg_section": "SRG",
    "filter_list_popover.trigger_more_filters": "Weitere Filter",
    "footer.made_by": "Gemacht von ",
    "form.accordion.hide_details": "Details ausblenden",
    "form.accordion.show_details": "Details anzeigen",
    "form.add_button": "Hinzufügen",
    "form.adding_button": "Wird hinzugefügt...",
    "form.cancel_button": "Abbrechen",
    "form.create_space_button": "Raum erstellen",
    "form.edit_button": "Bearbeiten",
    "form.other": "Andere",
    "form.remove_button": "Entfernen",
    "form.required_label": "{label} (erforderlich)",
    "form.save_button": "Speichern",
    "form.uncheck_all": "Alle abwählen",
    "form.update_button": "Posten",
    "format.count_noun": "{count} {noun}",
    "invite_user.button": "Benutzer einladen",
    "invite_user.error": "Einladen von {email} fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "invite_user.modal.editor_subheading": "Laden Sie jemanden ein, in den PSI-Tools ein [Redakteur](https://newpublic.notion.site/Technical-support-2e7fbd65fb3e80e39f11f750d0f5b129) zu sein.",
    "invite_user.modal.email_label": "E-Mail-Adresse",
    "invite_user.modal.heading": "Benutzer einladen",
    "invite_user.modal.invite_button": "Einladen",
    "invite_user.success": "{email} wurde eingeladen.",
    "language.de-CH": "Deutsch (Schweiz)",
    "language.de-DE": "Deutsch",
    "language.en-US": "Englisch",
    "language.fr-BE": "Französisch (Belgien)",
    "language.fr-CA": "Französisch (Kanada)",
    "language.fr-CH": "Französisch (Schweiz)",
    "language.fr-FR": "Französisch",
    "language.it-CH": "Italienisch (Schweiz)",
    "language.it-IT": "Italienisch",
    "language.nl-NL": "Niederländisch",
    "language.rm-CH": "Rätoromanisch (Schweiz)",
    "legal.privacy_notice": "Datenschutzhinweis",
    "legal.terms_of_service": "Nutzungsbedingungen",
    "linked_partner_story.incomplete_list_banner": "Diese Liste von Geschichten ist möglicherweise unvollständig.",
    "linked_partner_story.linked_articles_description": "Geschichten ansehen, die mit diesem Gespräch verbunden sind.",
    "linked_partner_story.linked_articles_heading": "Verknüpfte Geschichten",
    "linked_partner_story.no_articles_found": "Es sind noch keine Geschichten mit diesem Bereich verknüpft.",
    "linked_partner_story.read_article_link": "Artikel lesen",
    "linked_partner_story.view_video_link": "Video ansehen",
    "llm_ranking.best": "Beste",
    "loading": "Lädt...",
    "login.account_blocked_explanation": "Es ist keine Aktion erforderlich. Nur ein Moderator kann Ihren Zugang zur Diskussion wiederherstellen.",
    "login.account_blocked_heading": "Sie können sich nicht anmelden, weil Ihr Konto blockiert ist",
    "login.account_not_impacted": "Ihr {siloName} Konto ist nicht betroffen und immer noch zugänglich.",
    "login.continue_with": "Mit {providerName} fortfahren",
    "login.continue_with_google": "Mit Google fortfahren",
    "login.default_admin_login_heading_label": "Willkommen bei {psiBrandName}",
    "login.default_admin_login_subheading_label": "Melden Sie sich mit Ihrem Administratorkonto an, um zu beginnen",
    "login.default_login_heading_label": "Ein Raum für gesunde Diskussionen und verschiedene Perspektiven",
    "login.dev_login": "Entwickler-Login",
    "login.logging_in": "Anmeldung...",
    "login.okay_button": "Okay",
    "login.select_dev_persona": "Wählen Sie eine Entwickler-Persona",
    "login.sso_error": "Beim Anmelden ist etwas schiefgelaufen. Bitte schließen Sie dieses Fenster und versuchen Sie es erneut.",
    "main.checkbox.label": "Neue Beiträge „in Prüfung“",
    "modal.cancel_button": "Abbrechen",
    "modal.confirm_leave_button": "Verlassen",
    "moddashboard.cannot_reply": "Sie können auf diesen Beitrag nicht antworten.",
    "moddashboard.cannot_reply_deleted": "Sie können auf einen gelöschten Beitrag nicht antworten.",
    "moddashboard.failed_to_post_reply": "Antwort konnte nicht veröffentlicht werden",
    "moddashboard.publicly_reply_as": "Öffentlich antworten als",
    "moddashboard.reply_description": "Ihre Antwort wird im Konversationsbereich veröffentlicht und ist für alle Benutzer sichtbar.",
    "moddashboard.reply_posted_successfully": "Ihre Antwort wurde erfolgreich veröffentlicht",
    "moddashboard.reply_to_user": "{userName} antworten...",
    "moddashboard.your_reply": "Ihre Antwort",
    "moderate_dialog.locked_name": "{name} überprüft",
    "moderate_spaces.title": "Räume moderieren",
    "moderation.admin_bypass_ai_and_manual_moderation": "Dieser Bereich hat KI- und manuelle Moderation aktiviert, aber Sie umgehen beide automatisch als Admin-Benutzer.",
    "moderation.admin_bypass_ai_moderation": "Dieser Bereich hat KI-Moderation aktiviert, aber Sie umgehen diese automatisch als Admin-Benutzer.",
    "moderation.admin_bypass_flag": "Sie haben eine KI-Markierung umgangen",
    "moderation.admin_bypass_manual_moderation": "Dieser Bereich hat manuelle Moderation aktiviert, aber Sie umgehen diese automatisch als Admin-Benutzer.",
    "moderation.admin_bypassed": "⚠️ Die KI hat Ihre Antwort markiert, aber Sie haben sie automatisch als Admin-Benutzer umgangen.",
    "moderation.admin_filter_notice": "Um die KI-Moderation zu verbessern, senden Sie bitte einen Screenshot Ihres Beitrags und dieser Nachricht an Ihr Team.",
    "moderation.ai_and_manual_label": "KI- und manuell moderiert",
    "moderation.ai_flag": "KI-Markierung",
    "moderation.ai_mistake_explanation": "KI hilft uns, Kommentare zu moderieren, kann aber manchmal Fehler machen. Wenn die KI Sie daran hindert, eine respektvolle Meinung zu teilen, senden Sie Ihren Kommentar zur Überprüfung an einen Moderator.",
    "moderation.ai_wrong_question": "Hat die KI einen Fehler gemacht?",
    "moderation.approved_tag": "Genehmigt",
    "moderation.automaticallyApproved": "Automatisch genehmigt",
    "moderation.awaitingDecision": "Entscheidung ausstehend",
    "moderation.blocked": "Gesperrt",
    "moderation.bypassedPremoderation": "Premoderation umgangen",
    "moderation.dash.add_explanation_to_user": "Erklärung für den Benutzer hinzufügen",
    "moderation.dash.approve": "Genehmigen",
    "moderation.dash.approve_toast": "Erfolgreich genehmigt",
    "moderation.dash.base_filter._rejected": "Manuell abgelehnt",
    "moderation.dash.base_filter.auto_approved": "Automatisch genehmigt",
    "moderation.dash.base_filter.awaiting_decision": "Entscheidung ausstehend",
    "moderation.dash.base_filter.bypassed_premod": "Vormoderation umgangen",
    "moderation.dash.base_filter.deleted_by_user": "Vom Benutzer gelöscht",
    "moderation.dash.base_filter.manually_approved": "Manuell genehmigt",
    "moderation.dash.base_filter.my_bookmarks": "Meine Lesezeichen",
    "moderation.dash.base_filter.warnings": "Warnungen",
    "moderation.dash.block": "Blockieren",
    "moderation.dash.block_user": "Benutzer blockieren",
    "moderation.dash.blocked": "Blockiert",
    "moderation.dash.blocking_info": "Der Benutzer kann sich nicht mehr im Diskussionsbereich anmelden. Ein Benutzer muss 2 Mal verwarnt werden, bevor er blockiert werden kann.",
    "moderation.dash.cancel_rejection": "Abbrechen",
    "moderation.dash.explanation_to_user": "Erklärung für den Benutzer",
    "moderation.dash.feature_disabled": "Diese Funktion ist deaktiviert.",
    "moderation.dash.finish_rejecting": "Ablehnung abschließen",
    "moderation.dash.operation_error": "Der Vorgang konnte nicht ausgeführt werden, bitte versuche es erneut",
    "moderation.dash.reject": "Ablehnen",
    "moderation.dash.reject_toast": "Erfolgreich abgelehnt",
    "moderation.dash.select_all_that_apply": "Wählen Sie alle zutreffenden aus.",
    "moderation.dash.this_account_is_blocked": "🚫 Dieses Konto ist blockiert.",
    "moderation.dash.time": "mal",
    "moderation.dash.times": "mal",
    "moderation.dash.user_already_warned": "Dieser Benutzer wurde bereits {count} {noun} verwarnt.",
    "moderation.dash.user_successfully_unblocked": "{user} wurde erfolgreich freigeschaltet",
    "moderation.dash.user_successfully_warned": "{user} erfolgreich verwarnt",
    "moderation.dash.warn_or_block_user": "Benutzer verwarnen oder blockieren?",
    "moderation.dash.warn_user": "Benutzer verwarnen",
    "moderation.dash.warning_email_info": "Der Benutzer erhält eine E-Mail-Benachrichtigung, dass er verwarnt wurde. Sie können die Verwarnung später aus dem Benutzerkonto entfernen.",
    "moderation.dash.what_guidelines_violated": "Welche Richtlinien verletzt dieser Kommentar?",
    "moderation.deletedByUser": "Vom Benutzer gelöscht",
    "moderation.deletedUser": "Gelöschter Benutzer",
    "moderation.edit_your_post_button": "Bearbeiten Sie Ihren Beitrag",
    "moderation.email_notification": "Sie erhalten eine E-Mail-Benachrichtigung, wenn Ihr Beitrag von den Moderatoren genehmigt oder abgelehnt wird.",
    "moderation.email_notification_notice": "Sie erhalten eine E-Mail-Benachrichtigung, wenn Ihr Beitrag von den Moderatoren genehmigt oder abgelehnt wird.",
    "moderation.heated": "Hitzig",
    "moderation.incompatible_warning": "AI Review hat ergeben, dass Ihre {moderatedThing} möglicherweise nicht mit den folgenden [Community-Regeln]($onPress) übereinstimmt: ",
    "moderation.infoBannerLoader.label": "Überprüfung Ihrer Antwort...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Um eine einladende und respektvolle Umgebung zu gewährleisten, werden alle Beiträge in diesem Bereich sowohl von KI als auch manuell moderiert, bevor sie veröffentlicht werden, um sicherzustellen, dass sie den [Community-Richtlinien]($onPress) entsprechen.",
    "moderation.info_ai_moderation_banner_text": "Um eine einladende und respektvolle Umgebung zu gewährleisten, verwendet dieser Bereich KI, um Kommentare zu moderieren. KI kann Ihren Beitrag zur zusätzlichen Überprüfung markieren, wenn er nicht den [Community-Richtlinien]($onPress) entspricht.",
    "moderation.info_manual_moderation_banner_text": "Um eine einladende und respektvolle Umgebung zu gewährleisten, werden alle Beiträge in diesem Bereich manuell moderiert, bevor sie veröffentlicht werden, um den [Community-Richtlinien]($onPress) zu entsprechen.",
    "moderation.liveThread": "Live-Thread",
    "moderation.manuallyApproved": "Manuell genehmigt",
    "moderation.manuallyRejected": "Manuell abgelehnt",
    "moderation.message_to_moderator_placeholder": "Nachricht an den Moderator...",
    "moderation.mode_ai": "KI-Moderation",
    "moderation.mode_ai_and_manual": "KI- und manuelle Moderation",
    "moderation.mode_ai_post_anyway": "KI-Moderation mit trotzdem posten",
    "moderation.mode_manual": "Manuelle Moderation",
    "moderation.new": "Neu",
    "moderation.perspective_label": "Perspektivenetikett",
    "moderation.popular": "Beliebt",
    "moderation.post_without_editing_button": "Ohne Bearbeitung posten",
    "moderation.postedAnyway": "Trotzdem gepostet",
    "moderation.provide_details_help": "Geben Sie Details an, die uns helfen festzustellen, ob Ihr Beitrag unseren Community-Richtlinien entspricht.",
    "moderation.rejected_by_moderator": "Von Moderator abgelehnt",
    "moderation.reported_by_n_users": "Gemeldet von {count} Benutzern",
    "moderation.response": "Antwort",
    "moderation.select_all_that_apply": "Wählen Sie alle zutreffenden Optionen aus.",
    "moderation.send_for_review_button": "An einen Moderator zur Überprüfung senden",
    "moderation.send_to_moderator_button": "An Moderator senden",
    "moderation.send_to_moderator_title": "An Moderator senden",
    "moderation.sending": "Senden...",
    "moderation.sent_for_review_message": "Deine Antwort wurde an einen Moderator zurprüfung gesendet",
    "moderation.sent_to_moderator": "Deine Antwort wurde an einen Moderator zurprüfung gesendet",
    "moderation.sent_to_moderator_time": "An Moderator gesendet: {time}",
    "moderation.share_details": "Details angeben",
    "moderation.singularTerm": "Einzelbegriff",
    "moderation.system_unavailable_message": "Unser KI-Moderationssystem ist vorübergehend nicht verfügbar. Sie können Ihren Beitrag dennoch an einen menschlichen Moderator zur Überprüfung senden.",
    "moderation.system_unavailable_title": "⚠️ Moderationssystem vorübergehend nicht verfügbar",
    "moderation.take_second_look_rephrase": "📢 Ziehen Sie in Betracht, Ihre Nachricht umzuformulieren, um ein breiteres Publikum zu erreichen und bedeutungsvollere Diskussionen anzuregen.",
    "moderation.take_second_look_title": "Schauen Sie noch einmal hin",
    "moderation.take_second_look_warning": "❗️ Unsere KI-Überprüfung deutet darauf hin, dass Ihre Antwort Menschen abschrecken könnte, die Ihre Sichtweise nicht teilen.",
    "moderation.thank_you": "Danke!",
    "moderation.under_review": "In Überprüfung",
    "moderation.update_without_editing_button": "Ohne Bearbeitung aktualisieren",
    "moderation.use_ai_title": "✨ Wir nutzen AI für moderatoren",
    "moderation.warned": "Verwarnt",
    "moderation.what_guideline_violate": "Gegen welche Richtlinien verstößt dieser Kommentar?",
    "moderation.what_happens_next": "📫 Was passiert als nächstes",
    "moderation.zdfComment": "ZDF-Kommentar",
    "moderation_card.auto_translated": "Automatisch übersetzt",
    "moderation_card.language_tag": "{locale} | Übersetzt",
    "moderation_card.origin": "Herkunft:",
    "moderation_card.origin_not_available": "Keine Herkunft verfügbar",
    "moderation_card.show_original": "Original anzeigen ({locale})",
    "moderation_card.show_translation": "Übersetzung anzeigen ({locale})",
    "moderation_dash.add_your_notes": "Fügen Sie Ihre Notizen hinzu...",
    "moderation_dash.blocklist": "Blockliste",
    "moderation_dash.channel_settings": "Kanaleinstellungen",
    "moderation_dash.community_guideline_violation": "⚠️ Verstoß gegen die Community-Richtlinien",
    "moderation_dash.count_users": "{count} Benutzer",
    "moderation_dash.created_by": "Erstellt von",
    "moderation_dash.explanation_to_user": "Erklärung für den Benutzer",
    "moderation_dash.internal_notes": "Interne Notizen",
    "moderation_dash.manually_rejected": "Manuell abgelehnt",
    "moderation_dash.message_to_moderator": "Nachricht an den Moderator",
    "moderation_dash.moderate_spaces": "Räume moderieren",
    "moderation_dash.no_spaces": "Noch keine Räume",
    "moderation_dash.num_stories": "{numArticles} Geschichten",
    "moderation_dash.posts": "Beiträge",
    "moderation_dash.posts.title": "Beiträge moderieren",
    "moderation_dash.premod_eval_tab": "KI-Bewertung",
    "moderation_dash.queue.all_posts_hidden_plural": "{count} Beiträge werden durch die obigen Filter ausgeblendet.",
    "moderation_dash.queue.all_posts_hidden_singular": "1 Beitrag wird durch die obigen Filter ausgeblendet.",
    "moderation_dash.queue.load_more": "Mehr laden",
    "moderation_dash.queue.no_posts_yet": "Es gibt noch keine Beiträge.",
    "moderation_dash.rejected_by": "Abgelehnt von",
    "moderation_dash.reported_by": "Gemeldet von",
    "moderation_dash.selected_community_guideline_violation": "⚠️ Ausgewählter Verstoß gegen die Community-Richtlinien",
    "moderation_dash.user_report": "Benutzermeldung",
    "moderation_queue.button_filters": "Filter",
    "moderation_queue.clear_all": "Alle löschen",
    "moderationdash.user_information": "Benutzerinformationen",
    "moderationdash.user_metadata.comments_and_replies": "Beiträge:",
    "moderationdash.user_metadata.flagged_comments": "KI-gekennzeichnete Beiträge:",
    "moderationdash.user_metadata.rejected_comments": "Abgelehnte Beiträge:",
    "moderationdash.user_metadata.reported_comments": "Gemeldete Beiträge:",
    "moderationdash.user_metadata.user_warnings": "Warnungen:",
    "moderationtag.manually_moderated": "Manuell moderiert",
    "most_popular.most_popular_label": "Beliebteste",
    "most_popular.most_recent_label": "Neueste",
    "most_popular.show_more_button": "Mehr Antworten anzeigen",
    "neutral": "Neutral",
    "notification.dismiss_button": "Verwerfen",
    "notification.new_moderation_tasks": "Benachrichtigungen über neue Moderationsaufgaben, die zur Überprüfung bereit sind",
    "notification.new_moderation_tasks_settings": "Einstellungen für Benachrichtigungen über neue Moderationsaufgaben, die zur Überprüfung bereit sind",
    "notification.new_moderation_tasks_settings.checkboxMyChannels": "... in meinen Kanälen",
    "notification.new_moderation_tasks_settings.checkboxSpacesICreated": "... in von mir erstellten Spaces",
    "notification.new_moderation_tasks_settings.checkboxSpacesIFollow": "... in Spaces, denen ich folge",
    "onboarding.dismiss_button": "Schließen",
    "original_language": "Originalsprache",
    "pagination_row.next_page": "Nächste Seite",
    "pagination_row.previous_page": "Vorherige Seite",
    "pagination_row.showing": "Zeige {start}-{end} von {total}",
    "perspectives.add_new_perspective": "Eine neue Perspektive hinzufügen",
    "perspectives.add_your_own": "Füge deine eigene hinzu",
    "perspectives.add_your_perspective": "Füge deine Perspektive hinzu",
    "perspectives.dont_see_one": "Keinen passenden gefunden?",
    "perspectives.edit_invalid_characters": "Perspektiven-Bezeichnungen müssen mindestens einen Buchstaben enthalten",
    "perspectives.havent_heard_yet": "Wir haben noch nichts von diesen Perspektiven gehört",
    "perspectives.how_relate_question": "Wie stehst du zu diesem Thema?",
    "perspectives.poll_title": "Von wem wir gehört haben",
    "perspectives.share_thoughts_button": "Dein Beitrag zum Thema",
    "perspectives.title": "Perspektiven",
    "perspectives.write_in_duplicate": "Diese Perspektive existiert bereits – wähle sie aus der Liste aus",
    "perspectives.write_in_empty": "Gib eine Perspektivenbezeichnung ein",
    "perspectives.write_in_invalid_characters": "Perspektiven-Bezeichnungen müssen mindestens einen Buchstaben enthalten",
    "perspectives.write_in_no_emoji": "Emojis sind in eigenen Perspektiven nicht erlaubt",
    "perspectives.write_in_too_long": "Perspektivenbezeichnungen dürfen höchstens {max} Zeichen lang sein",
    "pin_comment.feature_label": "Hervorheben",
    "pin_comment.featured_label": "Herausgehoben",
    "pin_to_feed.move_down": "Nach unten bewegen",
    "pin_to_feed.move_up": "Nach oben bewegen",
    "pin_to_feed.pin_label": "Anpinnen",
    "pin_to_feed.pinned_label": "Angeheftet",
    "poll.recording_vote": "Stimme wird aufgezeichnet...",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (ihre stimme): {percent}%",
    "poll.you": "Du",
    "poll.you_comment": "Du ({comment})",
    "poll_question.add_option_button": "Option hinzufügen",
    "poll_question.option_placeholder": "Schreiben Sie Ihre Option...",
    "poll_question.options_label": "Umfrageoptionen",
    "poll_question.question_label": "Umfragefrage",
    "poll_question.question_placeholder": "Schreiben Sie Ihre Umfragefrage...",
    "poll_result.percent": "{percent}%",
    "popup.close_button": "Popup schließen",
    "popup_tip.more_information": "Mehr Informationen",
    "post.post_anyway_button": "Trotzdem posten",
    "post.posting_anyway": "Trotzdem posten...",
    "post.submit": "Senden",
    "post.submitting": "Wird übermittelt...",
    "post.update": "Aktualisieren",
    "post.update_anyway_button": "Trotzdem aktualisieren",
    "post.updating": "Wird aktualisiert...",
    "post.updating_anyway": "Trotzdem aktualisieren...",
    "premod_review.ai_eval_title": "KI-Bewertung",
    "premod_review.ai_flag_label": "KI-Markierung",
    "premod_review.badge_ai_correct": "KI korrekt",
    "premod_review.badge_ai_incorrect": "KI inkorrekt",
    "premod_review.badge_needs_evaluation": "Benötigt Bewertung",
    "premod_review.badge_wrong_reason": "Falscher Grund",
    "premod_review.based_on_evaluations": "Basierend auf {count} \"{verdict}\" Bewertungen",
    "premod_review.correct_rules_label": "Korrekte Regeln",
    "premod_review.disabled": "Die Datenerfassung für die Vorabmoderationsüberprüfung wurde auf diesem Server deaktiviert. Diese Funktion ist standardmäßig aktiviert. Um sie wieder zu aktivieren, entfernen Sie PREMOD_REVIEW_DISABLED=true aus der .env.",
    "premod_review.empty_state": "Es gibt keine Beiträge in dieser Kategorie zu bewerten.",
    "premod_review.evaluate_title": "KI-Markierung bewerten",
    "premod_review.evaluation_correct": "KI ist korrekt - Beitrag verstößt gegen Richtlinien",
    "premod_review.evaluation_incorrect": "KI ist inkorrekt - Beitrag sollte erlaubt sein",
    "premod_review.evaluation_set_tooltip": "Wir verwenden KI, um eine neue Reihe synthetischer Beiträge zu erstellen, die dieselben Randfälle aufweisen, wie sie in den hier gezeigten echten Beiträgen in den Bewertungsdaten auftreten.",
    "premod_review.evaluation_submitted_toast": "Ihre Bewertung wurde eingereicht",
    "premod_review.evaluation_wrong_reason": "Richtig zu blockieren, aber aus dem falschen Grund",
    "premod_review.evaluator_explanation": "Erklärung des Bewerters",
    "premod_review.expiration_tooltip": "Kommentare verfallen nach 30 Tagen, um unserer Datenschutzrichtlinie zu entsprechen.",
    "premod_review.expired": "Abgelaufen",
    "premod_review.expires_in": "Läuft ab in {days}d",
    "premod_review.export_description": "Laden Sie eine Datei mit tatsächlich überprüften Beiträgen aus dieser Bewertungskategorie herunter.",
    "premod_review.export_heading": "Bewertungsdaten für den Download generieren",
    "premod_review.file_format_label": "Dateiformat",
    "premod_review.file_ready": "{format}-Datei bereit!",
    "premod_review.filter_ai_correct": "KI korrekt",
    "premod_review.filter_ai_incorrect": "KI inkorrekt",
    "premod_review.filter_needs_evaluation": "Benötigt Bewertung",
    "premod_review.filter_wrong_reason": "Falscher Grund",
    "premod_review.format_csv": "CSV",
    "premod_review.format_json": "JSON",
    "premod_review.generate_data": "Daten generieren",
    "premod_review.loading": "Wird geladen...",
    "premod_review.moderate_posts_description": "Geben Sie Feedback zu den Entscheidungen der KI, Beiträge zur Moderation zu markieren. Diese Arbeit erstellt Bewertungsdatensätze, um die Genauigkeit der KI-Vormoderation im Laufe der Zeit zu verbessern.",
    "premod_review.post_label": "Beitrag",
    "premod_review.reason_description": "Dies wird verwendet, um synthetische Trainingsdaten zu generieren, um die KI zu verbessern.",
    "premod_review.reason_label": "Erklären Sie Ihre Bewertung",
    "premod_review.reason_placeholder": "z.B. \"Dies ist legitime politische Kritik, kein persönlicher Angriff\"",
    "premod_review.regenerate_data": "Daten neu generieren",
    "premod_review.select_format": "Exportformat auswählen",
    "premod_review.select_format_description": "Wählen Sie ein Dateiformat für Ihren Datenexport.",
    "premod_review.space_label": "Raum",
    "premod_review.submit": "Einreichen",
    "premod_review.submitting": "Wird übermittelt...",
    "premod_review.which_rules_violated_label": "Gegen welche Regeln verstößt dieser Beitrag tatsächlich?",
    "premod_review.why_not_ai_rules_label": "Warum verstößt der Beitrag nicht gegen die vom KI zitierten Regeln?",
    "premod_review.why_not_ai_rules_placeholder": "Erklären Sie, warum die vom KI zitierten Regeln nicht zutreffen...",
    "premod_review.why_violates_label": "Warum verstößt der Beitrag gegen diese Regeln?",
    "premod_review.why_violates_placeholder": "Erklären Sie, warum dieser Beitrag gegen die von Ihnen ausgewählten Regeln verstößt...",
    "premod_review.your_evaluation": "Ihre Bewertung (erforderlich)",
    "profile.add_custom_name": "Einen benutzerdefinierten Namen hinzufügen",
    "profile.collaboration_note": "Dieser Diskussionsraum wird von New_Public in Zusammenarbeit mit {psmName} gehostet.",
    "profile.custom_photo_label": "Benutzerdefiniertes Profilbild",
    "profile.edit.custom-title": "Fügen Sie einen benutzerdefinierten Titel hinzu",
    "profile.edit.custom_title": "Fügen Sie einen benutzerdefinierten Titel hinzu",
    "profile.edit.heading": "Bearbeiten",
    "profile.edit.name": "Profilname",
    "profile.edit.name_override": "Name",
    "profile.edit.name_override.placeholder": "Fügen Sie Ihren überschreibenden Namen hinzu...",
    "profile.edit.override_name_title": "Profilname überschreiben",
    "profile.edit.override_photo_title": "Profilfoto überschreiben",
    "profile.edit.photo": "Profilfoto",
    "profile.edit.photo_override": "Foto-URL",
    "profile.edit.photo_override.placeholder": "Fügen Sie Ihre überschreibende URL hinzu...",
    "profile.edit.title": "Titel",
    "profile.edit.windows_title": "Bearbeiten: {name}",
    "profile.edit_module_button": "{tLabel} bearbeiten",
    "profile.editorial_info": "Als Admin-Benutzer haben Sie Zugriff auf weitere Optionen für Ihr Profil im [Redaktions-Dashboard]({link}).",
    "profile.error_name_empty": "Benutzerdefinierte Namen dürfen nicht leer sein.",
    "profile.error_name_invalid": "Benutzerdefinierte Namen dürfen nur Kleinbuchstaben und Zahlen enthalten.",
    "profile.error_name_looks_real": "Benutzerdefinierte Namen dürfen nicht wie echte Namen aussehen.",
    "profile.error_name_taken": "Dieser benutzerdefinierte Name wird bereits verwendet.",
    "profile.error_name_violates": "Dieser benutzerdefinierte Name ist nicht mit unseren Community-Richtlinien kompatibel.",
    "profile.finish_button": "Fertig",
    "profile.go_to.edit": "Überschreibungen bearbeiten",
    "profile.is_titled_writer": "Ist betitelter Autor",
    "profile.loading": "Profil wird geladen...",
    "profile.module_name": "Name",
    "profile.module_photo_and_name": "Foto und Name",
    "profile.name_change_allowed_characters": "Benutzerdefinierte Namen dürfen nur Kleinbuchstaben und Zahlen enthalten.",
    "profile.name_label": "Profilname",
    "profile.no_user_error": "Kein solcher Benutzer",
    "profile.photo_label": "Dein Profilfoto",
    "profile.photo_url_aria": "Foto-URL",
    "profile.photo_url_placeholder": "Foto-URL",
    "profile.please_wait": "Bitte warten...",
    "profile.public_overriden": "Ihre Informationen wurden von einem Administrator bearbeitet",
    "profile.setup_title": "Profil einrichten",
    "profile.title_placeholder": "Titel eingeben",
    "profile.username_placeholder": "benutzer123",
    "profile.warn_overriden": "Ihre Informationen wurden im [Redaktions-Dashboard]({link}) von einem Administrator bearbeitet.",
    "profile_answers.admins_can_view": "Administratoren und Moderatoren können immer Ihren Verlauf einsehen.",
    "profile_answers.discussion_history": "Diskussionsverlauf",
    "profile_answers.edit_visibility": "Sichtbarkeit bearbeiten",
    "profile_answers.history_private": "Der Verlauf dieses Benutzers ist privat.",
    "profile_answers.load_more": "Mehr laden",
    "profile_answers.rejected": "Kommentar wurde von einem Moderator abgelehnt",
    "profile_answers.under_review": "Kommentar wird überprüft",
    "profile_answers.visible_to_everyone": "Für alle sichtbar",
    "profile_menu.dialog_label": "Profilmenü",
    "profile_menu.menu_label": "Konto",
    "prosocial_ranking.toggle_label": "Prosoziales Ranking",
    "puppet_test_support.login_user_a": "Als Benutzer A anmelden",
    "puppet_test_support.login_user_b": "Als Benutzer B anmelden",
    "puppet_test_support.login_user_c": "Als Benutzer C anmelden",
    "puppet_test_support.reset_silo": "Test-Silo zurücksetzen",
    "puppet_test_support.secret_label": "Puppet-Geheimnis",
    "puppet_test_support.title": "Puppet-Testwerkzeuge",
    "question.actions.close_modal_description": "Wenn geschlossen, wird ein Bereich „nur lesbar“. Die meisten Aktionen sind deaktiviert und Benutzer können nicht posten, antworten oder reagieren. Benutzer können weiterhin Kommentare melden. Sie können das Gespräch jederzeit wieder öffnen.",
    "question.actions.close_modal_heading": "Diesen Bereich schließen?",
    "question.actions.copy_button": "Kopieren",
    "question.actions.edit_button": "Bearbeiten",
    "question.actions.link_copied_toast": "Link in die Zwischenablage kopiert!",
    "question.actions.linked_stories_button": "Verknüpfte Geschichten",
    "question.actions.preview_button": "Vorschau",
    "question.actions.publish_button": "Veröffentlichen",
    "question.actions.publish_confirm_button": "Veröffentlichen",
    "question.actions.publish_modal_description": "Sobald veröffentlicht, wird dieser Bereich für Benutzer auf Ihrer Produktionsseite sichtbar und über SEO auffindbar sein. Stellen Sie sicher, dass Ihre Inhalte für die öffentliche Ansicht bereit sind. Sie können die Unterhaltung jederzeit schließen.",
    "question.actions.publish_modal_heading": "Diesen Bereich veröffentlichen?",
    "question.actions.publish_success_toast": "Bereich veröffentlicht",
    "question.actions.reopen_button": "Wieder öffnen",
    "question.actions.reopen_confirm_button": "Wieder öffnen",
    "question.actions.reopen_modal_description": "Öffnen Sie diesen Bereich erneut, um die Konversation wieder zu aktivieren.",
    "question.actions.reopen_modal_heading": "Diesen Raum wieder öffnen?",
    "question.actions.tooltip": "Weitere Optionen",
    "question.actions.unpublish_button": "Veröffentlichung zurücknehmen",
    "question.actions.unpublish_confirm_button": "Veröffentlichung zurücknehmen",
    "question.actions.unpublish_modal_description": "Sobald nicht mehr veröffentlicht, wird dieser Bereich für Benutzer auf Ihrer Produktionsseite nicht mehr sichtbar sein und nicht mehr für SEO indiziert. Sie können die Unterhaltung jederzeit erneut veröffentlichen.",
    "question.actions.unpublish_modal_heading": "Diesen Bereich nicht mehr veröffentlichen?",
    "question.actions.unpublish_success_toast": "Bereich nicht mehr veröffentlicht",
    "question.add_content_label": "Inhalt hinzufügen",
    "question.add_spaces_label": "Räume hinzufügen",
    "question.all_responses_tab": "Alle Kommentare",
    "question.conversation_format": "Gesprächsformat",
    "question.conversation_helper_section": "Gesprächshilfe",
    "question.conversation_type_section": "Gesprächstyp",
    "question.count_noun_format": "{count} {noun}",
    "question.edit_closed_banner": "Öffnen Sie diesen Bereich erneut, um ihn zu bearbeiten.",
    "question.edit_heading": "Bearbeiten",
    "question.edit_page_title": "Bearbeiten: {name}",
    "question.edit_thread_header_section": "Thread-Kopfzeile",
    "question.edit_view_only_banner": "Sie können die Einstellungen dieses Bereichs ansehen, aber nicht ändern.",
    "question.error_empty_prompt": "Die Eingabeaufforderung darf nicht leer sein.",
    "question.error_prompt_too_long": "Die Eingabeaufforderung muss weniger als {num} Zeichen umfassen.",
    "question.general_section": "Allgemein",
    "question.input_placeholder": "Dein Beitrag zum Thema...",
    "question.moderation_approach": "Moderationsansatz",
    "question.moderation_label": "Moderation",
    "question.no_comments_message": "Sei die erste Person, die ihre Gedanken teilt",
    "question.no_comments_title": "Beginne die Unterhaltung",
    "question.no_teaser_error": "Kein Teaser definiert",
    "question.not_exist": "Diese Frage existiert nicht",
    "question.playbook_link": "Siehe [editorial playbook]({url}) für weitere Informationen.",
    "question.prompt_label": "Prompt",
    "question.prosocial_format_label": "Prosocial Format",
    "question.prosocial_ranking_section": "Prosoziales Ranking",
    "question.public_response_subtitle": "Öffentlicher Beitrag",
    "question.reaction_list_tooltip": "Siehe Reaktionen",
    "question.reaction_plural": "reaktionen",
    "question.reaction_singular": "reaktion",
    "question.reply_placeholder": "Antworte {authorName}...",
    "question.reply_plural": "antworten",
    "question.reply_singular": "antworten",
    "question.select_format_placeholder": "Format auswählen",
    "question.select_moderation_placeholder": "Moderationseinstellung auswählen",
    "question.upvote_plural": "Abstimmungen",
    "question.upvote_singular": "Hochwählen",
    "ranking-eval.add_ranker": "Ranker hinzufügen",
    "ranking-eval.add_source": "Quelle hinzufügen",
    "ranking-eval.back": "Zurück",
    "ranking-eval.builtin_rankers_desc": "Sehen Sie sich die Eingabeaufforderungen der eingebauten Ranker an, um sie als Referenz beim Erstellen Ihrer eigenen zu verwenden.",
    "ranking-eval.builtin_rankers_title": "Eingebaute Ranker",
    "ranking-eval.cancel": "Abbrechen",
    "ranking-eval.cancel_edit": "Abbrechen",
    "ranking-eval.comment_count": "{count} Kommentare",
    "ranking-eval.comment_scoring_desc": "Bewerten Sie jeden Kommentar auf einer Skala von 1-5 Sternen",
    "ranking-eval.comments_random_order": "Kommentare in zufälliger Reihenfolge",
    "ranking-eval.conversation_count": "{count} Unterhaltungen",
    "ranking-eval.custom_rankers_desc": "Definieren Sie benutzerdefinierte, LLM-gesteuerte Ranker zur Verwendung in der nebeneinander Bewertung. Benutzerdefinierte Ranker erscheinen im Ranker-Dropdown.",
    "ranking-eval.custom_rankers_title": "Benutzerdefinierte Ranker",
    "ranking-eval.delete_ranker": "Löschen",
    "ranking-eval.delete_source": "Löschen",
    "ranking-eval.disabled": "(deaktiviert)",
    "ranking-eval.edit": "Bearbeiten",
    "ranking-eval.edit_ranker": "Ranker bearbeiten",
    "ranking-eval.edit_source": "Quelle bearbeiten",
    "ranking-eval.filter.all_sources": "Alle Quellen",
    "ranking-eval.filter_all": "Alle",
    "ranking-eval.filter_selected": "Ausgewählt",
    "ranking-eval.first_pass_placeholder": "Verwende {{question}} und {{commentText}}",
    "ranking-eval.first_pass_prompt": "Erster Durchgang Prompt",
    "ranking-eval.imported_at": "Abgerufen {time}",
    "ranking-eval.importing": "Gespräch wird importiert...",
    "ranking-eval.loading_ranker": "Lade Ranker...",
    "ranking-eval.model": "Modell",
    "ranking-eval.model_placeholder": "Modell auswählen",
    "ranking-eval.new_ranker": "Neuer Ranker",
    "ranking-eval.new_source": "Neue Quelle",
    "ranking-eval.next_button": "Weiter →",
    "ranking-eval.no_cached": "Noch keine Gespräche zwischengespeichert. Drücken Sie \"Von Quellen aktualisieren\", um Gespräche von Partnerseiten abzurufen.",
    "ranking-eval.no_comments": "Dieses Gespräch hat keine Kommentare.",
    "ranking-eval.no_conversations_match": "Keine Konversationen passen.",
    "ranking-eval.no_conversations_to_open": "Noch keine Konversationen. Fügen Sie auf der Registerkarte „Quellen“ Quellen hinzu und klicken Sie dann auf der Registerkarte „Konversationssatz“ auf „Aus Quellen aktualisieren“.",
    "ranking-eval.no_custom_rankers": "Noch keine benutzerdefinierten Ranker. Klicken Sie auf \"Ranker hinzufügen\", um einen zu erstellen.",
    "ranking-eval.no_other_ratings": "Noch keine anderen Bewertungen.",
    "ranking-eval.no_ratings_yet": "Noch keine Bewertungen.",
    "ranking-eval.no_sources": "Noch keine Quellen. Klicken Sie auf „Quelle hinzufügen“, um eine hinzuzufügen.",
    "ranking-eval.no_sources_to_fetch": "Noch keine Quellen. Fügen Sie im Tab „Quellen“ die PSI-Websites hinzu, von denen Daten abgerufen werden sollen.",
    "ranking-eval.no_spaces": "Noch keine Räume. Fügen Sie oben einen hinzu, um zu beginnen.",
    "ranking-eval.others_ratings": "Bewertungen von anderen",
    "ranking-eval.pick_conversation": "Gespräch auswählen",
    "ranking-eval.prev_button": "← Zurück",
    "ranking-eval.ranker_col.actions": "Aktionen",
    "ranking-eval.ranker_col.model": "Modell",
    "ranking-eval.ranker_col.name": "Name",
    "ranking-eval.ranker_col.thinking": "Denken",
    "ranking-eval.ranker_col.topn": "Top N",
    "ranking-eval.ranker_desc_placeholder": "Kurze Beschreibung",
    "ranking-eval.ranker_description": "Beschreibung",
    "ranking-eval.ranker_enabled": "Aktiviert",
    "ranking-eval.ranker_name": "Name",
    "ranking-eval.ranker_name_placeholder": "z.B. Konstruktive Debatte",
    "ranking-eval.ranking_scoring": "Kommentare werden bewertet... {scored} von {total}",
    "ranking-eval.ranking_selecting_top_10": "Top 10 werden ausgewählt... das kann eine Weile dauern",
    "ranking-eval.ranking_starting": "Ranking wird gestartet...",
    "ranking-eval.rating_reason_placeholder": "Warum diese Bewertung?",
    "ranking-eval.reasoning": "Denkebene",
    "ranking-eval.reasoning_placeholder": "Ebene auswählen",
    "ranking-eval.refresh": "Aus Quellen aktualisieren",
    "ranking-eval.refresh_comments": "Kommentare aktualisieren",
    "ranking-eval.refresh_comments_in_progress": "Kommentare werden aktualisiert...",
    "ranking-eval.refresh_in_progress": "Wird aktualisiert...",
    "ranking-eval.refreshing": "Abrufen von Gesprächen von Partnerseiten...",
    "ranking-eval.save_ranker": "Speichern",
    "ranking-eval.save_source": "Speichern",
    "ranking-eval.scoring_legend_title": "Bewertungsleitfaden",
    "ranking-eval.search_conversations": "Gespräche durchsuchen...",
    "ranking-eval.second_pass_placeholder": "Verwende {{question}} und {{comments}}",
    "ranking-eval.second_pass_prompt": "Zweiter Durchgang Prompt",
    "ranking-eval.select_conversation": "Konversation auswählen",
    "ranking-eval.select_ranker": "Ranker auswählen",
    "ranking-eval.side_by_side_desc": "Vergleichen Sie zwei Ranking-Algorithmen nebeneinander",
    "ranking-eval.source_base_url": "Basis-URL",
    "ranking-eval.source_base_url_placeholder": "z. B. https://psi.newpublic.org",
    "ranking-eval.source_col.actions": "Aktionen",
    "ranking-eval.source_col.base_url": "Basis-URL",
    "ranking-eval.source_col.key": "Schlüssel",
    "ranking-eval.source_col.label": "Bezeichnung",
    "ranking-eval.source_col.silo": "Silo",
    "ranking-eval.source_key": "Schlüssel",
    "ranking-eval.source_key_placeholder": "z. B. np",
    "ranking-eval.source_label": "Bezeichnung",
    "ranking-eval.source_label_placeholder": "z. B. New Public",
    "ranking-eval.source_remote_silo": "Silo",
    "ranking-eval.source_remote_silo_placeholder": "z. B. np",
    "ranking-eval.sources_desc": "PSI-Websites, von denen Konversationen abgerufen werden. „Aus Quellen aktualisieren“ im Tab „Konversationssatz“ liest jede davon ein.",
    "ranking-eval.sources_title": "Quellen",
    "ranking-eval.sources_unreachable": "{baseUrls} konnten nicht erreicht werden. Prüfen Sie auf der Registerkarte „Quellen“, ob die Basis-URL korrekt ist.",
    "ranking-eval.spaces.column_actions": "Aktionen",
    "ranking-eval.spaces.column_comments": "Kommentare",
    "ranking-eval.spaces.column_created": "Erstellt",
    "ranking-eval.spaces.column_name": "Name",
    "ranking-eval.spaces.score_comments": "Kommentare bewerten",
    "ranking-eval.spaces.side_by_side": "Nebeneinander",
    "ranking-eval.spaces.title": "Räume",
    "ranking-eval.submit_rating": "Bewertung abschicken",
    "ranking-eval.tab.comment_scoring": "Kommentarbewertung",
    "ranking-eval.tab.conversation_set": "Konversationssatz",
    "ranking-eval.tab.custom_rankers": "Benutzerdefinierte Ranker",
    "ranking-eval.tab.side_by_side": "Nebeneinander",
    "ranking-eval.tab.sources": "Quellen",
    "ranking-eval.title": "Ranking-Bewertung",
    "ranking-eval.top_n": "Top N",
    "ranking-eval.top_n_placeholder": "20",
    "ranking-eval.top_ten_reasoning": "Top 10 Begründungen:",
    "ranking-eval.update_rating": "Bewertung aktualisieren",
    "ranking-eval.view": "Ansicht",
    "ranking-eval.vote_a_best": "{ranker} ist am besten",
    "ranking-eval.vote_b_best": "{ranker} ist am besten",
    "ranking-eval.vote_tie": "Gleich",
    "ranking_debug.recompute": "Rangfolge neu berechnen",
    "ranking_debug.recomputing": "Rangfolge wird neu berechnet…",
    "ranking_debug.toggle": "Ranking-Debug-Informationen anzeigen",
    "ranking_debug.top_ten_reasoning": "Top-10-Begründung:",
    "ranking_eval.show_debug_info": "Debug-Informationen anzeigen",
    "rating.its_complicated": "Es ist kompliziert",
    "rating.no_with_reservations": "Nein, aber mit Vorbehalten",
    "rating.strongly_no": "Stark nein",
    "rating.strongly_yes": "Stark ja",
    "rating.yes_with_reservations": "Ja, aber mit Vorbehalten",
    "reaction_types.appreciation_plural": "appreciations",
    "reaction_types.appreciation_singular": "appreciation",
    "reaction_types.constructive": "Konstruktiv",
    "reaction_types.controversial": "Kontrovers",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Standard-Set",
    "reaction_types.empathetic": "Empathisch",
    "reaction_types.enjoyable": "Genießbar",
    "reaction_types.fun_space": "Lustiges Raum",
    "reaction_types.funny": "Lustig",
    "reaction_types.helpful": "Hilfreich",
    "reaction_types.insightful": "Interessant",
    "reaction_types.interesting": "Interessant",
    "reaction_types.nuanced": "Nuanciert",
    "reaction_types.personal_space": "Persönlicher Raum",
    "reaction_types.playful": "Spielend",
    "reaction_types.reaction_set_label": "Reaktions-Set",
    "reaction_types.recording": "Reaktion wird aufgezeichnet...",
    "reaction_types.relatable": "Nachvollziehbar",
    "reaction_types.serious_space": "Seriöser Raum",
    "reaction_types.surprising": "Überraschend",
    "reaction_types.why_appreciate": "Warum schätzen Sie diesen Beitrag?",
    "related_content.add_content_button": "Inhalt hinzufügen",
    "related_content.article_option": "Artikel",
    "related_content.audio_option": "Audio",
    "related_content.invalid_url_error": "Ungültiges URL-Format. Bitte geben Sie eine gültige URL ein.",
    "related_content.label": "Verwandter Inhalt",
    "related_content.learn_more": "Erfahre mehr zu diesem Thema",
    "related_content.retrieve_article_error": "Artikelinformationen können nicht abgerufen werden. Bitte überprüfen Sie die URL und versuchen Sie es erneut.",
    "related_content.show_more_button": "Mehr anzeigen",
    "related_content.story_format_label": "Geschichtenformat",
    "related_content.story_url_label": "Geschichten-URL",
    "related_content.url_placeholder": "https://www.beispiel.com",
    "related_content.video_option": "Video",
    "related_conversations.add_hint": "Bis zu vier Räume hinzufügen.",
    "related_conversations.add_spaces_button": "Räume hinzufügen",
    "related_conversations.limit_reached_error": "Für diesen Bereich sind bereits vier verknüpfte Bereiche ausgewählt. Entfernen Sie einen, bevor Sie einen weiteren hinzufügen.",
    "related_conversations.next_button": "Nächste",
    "related_conversations.no_spaces_available": "Keine Plätze verfügbar",
    "related_conversations.no_spaces_found": "Keine Plätze gefunden",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.previous_button": "Vorherige",
    "related_conversations.title": "Verwandte Konversationen",
    "representing_perspectives_template.description": "Bitten Sie Benutzer aus einer bestimmten Perspektive, auf Ihre Frage zu antworten.",
    "representing_perspectives_template.description_1": "Wählen Sie **3-5 spezifische Perspektiven** aus, von denen Sie hören möchten (z. B. „🏖️ Rentner“, „📦 Neubürger“, „🍼 Arbeitender Elternteil“ usw.)",
    "representing_perspectives_template.description_2": "Vermeiden Sie demografische Perspektiven (z. B. „städtisch“, „geringes Einkommen“, „Frau“ usw.), die zu Stereotypen führen könnten",
    "representing_perspectives_template.description_3": "Vermeiden Sie es, Perspektiven Überzeugungen zuzuschreiben (z. B. „Person mit konservativer Haltung“ oder „Befürworter“ und „Gegner“)",
    "representing_perspectives_template.description_4": "Wählen Sie ein Emoji für jede Perspektive",
    "representing_perspectives_template.description_5": "Trennen Sie Perspektiven durch einen Zeilenumbruch.",
    "representing_perspectives_template.form_field_label": "Perspektiven",
    "representing_perspectives_template.helper_label": "Perspektiven definieren",
    "representing_perspectives_template.label": "Perspektiven darstellen",
    "representing_perspectives_template.placeholder": "Schreiben Sie 3-5 Perspektiven...",
    "roles.editor": "Redakteur",
    "roles.moderator": "Moderator",
    "roles.observer": "Beobachter",
    "roles.owner": "Eigentümer",
    "roles.unknown": "Unbekannt",
    "satisfaction_survey_popover.question": "Wie zufrieden sind Sie mit dieser Konversationsplattform?",
    "satisfaction_survey_popover.satisfied_label": "Sehr zufrieden",
    "satisfaction_survey_popover.unsatisfied_label": "Sehr unzufrieden",
    "saving": "Speichern...",
    "search.no_members_found": "Keine Mitglieder gefunden",
    "search.placeholder": "Suche",
    "settings.add_feature_button": "Funktion hinzufügen",
    "settings.add_format_button": "Format hinzufügen",
    "settings.add_to_organization_button": "Zur Organisation hinzufügen",
    "settings.added_button": "Hinzugefügt",
    "settings.added_format_button": "Hinzugefügt",
    "settings.additional_features_heading": "Zusätzliche Funktionen",
    "settings.ai_and_manual_moderation_description": "Erfordern Sie, dass alle von Benutzern eingereichten Beiträge sowohl die KI- als auch die manuelle Überprüfung bestehen, bevor sie veröffentlicht werden.",
    "settings.ai_pre_moderation_description": "Verwenden Sie KI, um sicherzustellen, dass von Benutzern eingereichte Beiträge den Community-Richtlinien entsprechen, bevor sie veröffentlicht werden.",
    "settings.ai_pre_moderation_with_post_anyway_description": "Erlauben Sie Benutzern, Beiträge zu veröffentlichen, die von der KI als minderwertig, aber nicht schädlich eingestuft werden, und ordnen Sie sie niedriger im Feed ein.",
    "settings.audience_input_description": "Fragen, Testimonials und Geschichten von Nutzern sammeln. Dies erlaubt eine größere Bandbreite an Engagement.",
    "settings.audience_input_label": "Zielgruppe",
    "settings.blocklist_description": "Blockieren Sie bestimmte Wörter aus allen von Benutzern übermittelten Beiträgen.",
    "settings.channels_description": "Organisieren Sie Bereiche in getrennten Kanälen, damit sich Redaktions- und Moderationsteams auf relevante Inhalte konzentrieren können.",
    "settings.comment_slider_description": "Bitten Sie die Benutzer, Ihre Frage anhand eines Spektrums zu beantworten (z. B. „Überhaupt nicht“ bis „Überhaupt ja“).",
    "settings.comment_slider_label": "Kommentar-Slider",
    "settings.conversation_home": "Gesprächsübersicht",
    "settings.conversation_home_description": "Öffentliche Seite, die alle aktiven und abgeschlossenen Gespräche aus dem Silo zeigt",
    "settings.dialogue_description": "Bitten Sie die Benutzer, Ihre Frage mit einem einfachen „Ja“ oder „Nein“ zu beantworten.",
    "settings.dialogue_label": "Dialog",
    "settings.heading": "{psiBrandName} Einstellungen",
    "settings.labs_description": "Prosoziale Formate in früheren Entwicklungsstadien, die zum Experimentieren bereitstehen. Die Labs-Funktionen sind voll funktionsfähig, verfügen jedoch nicht über standardisierte Voreinstellungen und können sich im Laufe der Zeit ändern.",
    "settings.labs_heading": "Labs",
    "settings.manual_moderation_description": "Erfordern Sie, dass alle von Benutzern eingereichten Beiträge die manuelle Überprüfung bestehen, bevor sie veröffentlicht werden; verwendet keine KI für die Moderation.",
    "settings.moderation_heading": "Moderation",
    "settings.premod_review_tab_description": "Fügen Sie im Moderations-Dashboard eine Registerkarte hinzu, auf der Moderatorinnen und Moderatoren jede von der KI getroffene Entscheidung überprüfen und festhalten, ob sie richtig war.",
    "settings.premod_review_tab_label": "KI-Bewertungsregisterkarte",
    "settings.prosocial_formats_description": "Jeder Diskussionsraum ist durch ein prosoziales Leitformat strukturiert.",
    "settings.prosocial_formats_heading": "Prosocial Formate",
    "settings.prosocial_ranking_description": "Die aufschlussreichsten und konstruktivsten Kommentare werden automatisch oben im Feed angezeigt.",
    "settings.prosocial_ranking_label": "Prosoziales Ranking",
    "settings.representing_perspectives_description": "Bitten Sie Benutzer aus einer bestimmten Perspektive, auf Ihre Frage zu antworten.",
    "settings.representing_perspectives_label": "Perspektiven darstellen",
    "settings.stories_description": "Verknüpfen Sie veröffentlichte Story-URLs mit Konversationsbereichen, damit eine eingebettete Konversation auf den von Ihnen ausgewählten Seiten geladen wird. Erfordert zusätzliche Entwicklerkonfiguration.",
    "settings.stories_label": "Storys",
    "settings.titled_writers_description": "Identifizieren Sie ausgewählte Benutzer als verifizierte Mitglieder Ihrer Organisation beim Schreiben von Kommentaren oder Antworten auf andere.",
    "settings.titled_writers_label": "Titulierte Autoren",
    "settings.video_voting_description": "Überlagern Sie Fragen mit Videoinhalten.",
    "settings.video_voting_label": "Video Voting",
    "simple_ranking.most_reactions": "Am meisten reagiert",
    "simple_ranking.newest": "Neueste",
    "single_response_help.same_question_title": "Anderer Inhalt, gleiche Frage?",
    "single_response_help.update_response_label": "Aktualisiere deinen bisherigen Beitrag mit neuen Erkenntnissen.",
    "slider_with_stop_points.aria_label": "Verwenden Sie die Pfeiltasten nach links und rechts oder nach oben und unten, um den Schieberegler zu verändern",
    "sort.all": "Alle",
    "sort.ascending": "A-Z",
    "sort.most_recent": "Neueste",
    "sort.top": "Top",
    "sort.top_voted": "Am meisten abgestimmt",
    "sort_button.aria_label": "Sortieren nach {text}",
    "sort_menu.sort_by_header": "Sortieren nach",
    "sorting.most_recent": "Neueste",
    "sorting.oldest": "Älteste",
    "space.detail.id": "ID:",
    "space.detail.linkes.stories": "Verknüpfte Geschichten:",
    "space.detail.posts": "Beiträge:",
    "space.table.demo.name": "Name",
    "space.table.demo.responses": "Beiträge",
    "space.table.search": "Suche",
    "spaces.column_actions": "Aktionen",
    "spaces.column_created": "Erstellt",
    "spaces.column_format": "Format",
    "spaces.column_name": "Name",
    "spaces.column_needs_review": "Muss überprüft werden",
    "spaces.column_notification_follow": "Folgen",
    "spaces.column_notification_following": "Folgend",
    "spaces.column_notifications": "Benachrichtigungen",
    "spaces.column_responses": "Beiträge",
    "spaces.column_status": "Status",
    "spaces.draft_created": "Entwurfsbereich erstellt",
    "spaces.draft_not_created": "Fehler: Entwurfsbereich nicht erstellt",
    "spaces.filter_closed": "Geschlossen",
    "spaces.filter_draft": "Entwurf",
    "spaces.filter_heated": "Beheizt",
    "spaces.filter_needs_review": "Muss überprüft werden",
    "spaces.format_required_label": "Prosocial Format (erforderlich)",
    "spaces.kickstart_conversation_tip": "Starten Sie dieses Gespräch, indem Sie mindestens drei Kommentare hinzufügen.",
    "spaces.new_button": "Neuer Raum",
    "spaces.new_space_title": "Neuer Raum",
    "spaces.no_spaces_found": "Keine Plätze gefunden",
    "spaces.no_spaces_yet": "Noch keine Plätze frei",
    "spaces.no_templates_message": "Keine Vorlagen verfügbar",
    "spaces.prompt_help_avoid": "Vermeiden:",
    "spaces.prompt_help_avoid_1": "Suggestivfragen",
    "spaces.prompt_help_avoid_2": "Rein theoretische Themen",
    "spaces.prompt_help_good_prompts": "Gute Aufforderungen sind:",
    "spaces.prompt_help_tip_1": "Rechtzeitig, spezifisch, kulturell relevant",
    "spaces.prompt_help_tip_2": "Offen für Debatte und Diskussion",
    "spaces.prompt_help_tip_3": "Klar und offen, aber nicht abstrakt",
    "spaces.prompt_help_title": "Brauchen Sie Hilfe beim Schreiben?",
    "spaces.prompt_label": "Prompt",
    "spaces.prompt_placeholder": "Schreiben Sie eine Frage oder einen Diskussionsprompt...",
    "spaces.status_closed": "Geschlossen",
    "spaces.status_draft": "Entwurf",
    "spaces.still_need_help": "Noch Hilfe benötigt?",
    "spaces.tab_label": "Räume",
    "spaces.title": "Räume",
    "spaces.visit_playbook": "Besuchen Sie das PSI Playbook",
    "srg.profile.error_name_invalid": "Benutzerdefinierte Namen dürfen nur Buchstaben, Zahlen, Leerzeichen und Bindestriche enthalten.",
    "standalone_question.participant": "Teilnehmer",
    "standalone_question.participants": "Teilnehmer",
    "status.creation_successful": "Erstellung erfolgreich",
    "status.edit_successful": "Bearbeitung erfolgreich",
    "status.reported": "Gemeldet",
    "story_dash.action_attach_spaces": "Räume anhängen",
    "story_dash.action_edit_spaces": "Verknüpfte Räume bearbeiten",
    "story_dash.action_remove": "Entfernen",
    "story_dash.action_view": "Geschichte anzeigen",
    "story_dash.actions_column": "Aktionen",
    "story_dash.add_story_button": "Geschichte hinzufügen",
    "story_dash.add_title": "Geschichte hinzufügen",
    "story_dash.attach_space_label": "Räume",
    "story_dash.attach_space_modal_heading": "Räume anhängen",
    "story_dash.attach_spaces": "Räume anhängen",
    "story_dash.attach_spaces_button": "Räume anhängen",
    "story_dash.attach_spaces_description": "Vorhandene(n) Raum/Räume mit dieser Story verknüpfen.",
    "story_dash.attach_spaces_modal_description": "Vorhandene(n) Bereich(e) mit dieser Story verknüpfen.",
    "story_dash.attached_spaces_more": "+{count} mehr",
    "story_dash.cancel_button": "Abbrechen",
    "story_dash.connected_space_column": "Verbundene Räume",
    "story_dash.create_button": "Geschichte hinzufügen",
    "story_dash.date_column": "Veröffentlicht",
    "story_dash.domains_column": "Domänen",
    "story_dash.filter_all": "Alle",
    "story_dash.invalid_url_error": "Bitte geben Sie eine gültige URL ein",
    "story_dash.name_column": "Name",
    "story_dash.no_matches": "Keine Geschichten entsprechen Ihrer Suche.",
    "story_dash.no_stories": "Noch keine Geschichten. Fügen Sie eine Geschichte hinzu, um zu beginnen.",
    "story_dash.remove_confirm_button": "Entfernen",
    "story_dash.remove_modal_description": "Diese Aktion kann nicht rückgängig gemacht werden. Alle angehängten Räume werden getrennt.",
    "story_dash.remove_modal_description_2": "Sie können diese Geschichte jederzeit erneut hinzufügen und Räume damit verknüpfen.",
    "story_dash.remove_modal_heading": "Diese Geschichte entfernen?",
    "story_dash.save_button": "Speichern",
    "story_dash.search": "Suchen...",
    "story_dash.search_placeholder": "Suchen...",
    "story_dash.spaces_updated_toast": "Räume aktualisiert",
    "story_dash.story_added_toast": "Geschichte hinzugefügt",
    "story_dash.story_removed_toast": "Story entfernt und Raum/Räume nicht mehr verbunden",
    "story_dash.story_url_label": "Geschichte-URL",
    "story_dash.tab": "Geschichten",
    "story_dash.table_heading": "Geschichten",
    "story_dash.url_description": "Fügen Sie einen Artikel, ein Video oder andere Medien hinzu.",
    "story_dash.url_placeholder": "www.beispiel.com",
    "strongly_agree": "Stark zustimmen",
    "strongly_disagree": "Stark widersprechen",
    "survey.feedback_help": "Ihr Feedback wird uns helfen, Ihre Erfahrung zu verbessern.",
    "survey.strongly_agree": "Stark zustimmen",
    "survey.strongly_disagree": "Stark widersprechen",
    "survey.tell_us_experience": "Erzählen Sie uns von Ihrer Erfahrung",
    "survey.thank_you": "Vielen Dank, dass Sie Ihre Erfahrung mit uns geteilt haben!",
    "suspension.block_user_confirm": "{userName} blockieren?",
    "suspension.moderator_unwarned_you": "Ein Moderator hat Sie entwarnt",
    "suspension.unblock_user_confirm": "{userName} entsperren?",
    "table_grid.empty": "Noch nichts hier",
    "tag.beta": "Beta",
    "template.perspectives_description": "Trennen Sie Perspektiven durch einen Zeilenumbruch.",
    "template.perspectives_label": "Perspektiven",
    "text.character_count": "{count}/{max} Zeichen",
    "text.character_count_max": "{count}/{max} Zeichen max",
    "text.character_count_min": "{min} Zeichen min",
    "text.character_count_over_max": "{count}/{max} Zeichen max",
    "text.character_count_progress_min": "{count}/{min} Zeichen min",
    "tile.experimental_label": "Beta",
    "tile.outdated_label": "Veraltet",
    "time.format": "{time}",
    "upvote.aria_label": "Hochwählen",
    "upvote.count": "{count}",
    "upvote.recording": "Upvote wird aufgezeichnet...",
    "usability_survey.easy_to_use_question": "Diese Konversationsplattform ist einfach zu bedienen",
    "usability_survey.meets_needs_question": "Diese Konversationsplattform erfüllt meine Bedürfnisse",
    "user.member": "Mitglied",
    "user_info.account_button": "Konto",
    "user_info.admin": "Admin",
    "user_info.developer_features": "Entwicklerfunktionen",
    "user_info.faqs": "FAQs",
    "user_info.log_in_button": "Anmelden",
    "user_info.log_out_button": "Abmelden",
    "user_info.profile_button": "Profil",
    "user_info.profile_menu_aria_label": "Profilmenü für {name}",
    "video_link.go_to_video": "Zum Video",
    "video_voting.continue_button": "Fortsetzen",
    "video_voting.create_new_voting": "Neue Abstimmung erstellen",
    "video_voting.current_session_state": "Aktuelles Sitzungsstatusobjekt",
    "video_voting.deactivate_all": " kannst du die Funktion generell deaktivieren.",
    "video_voting.edit_title": "Video-Abstimmung bearbeiten",
    "video_voting.enable_all_videos": "Voting für alle Videos aktivieren",
    "video_voting.enable_voting": "Voting aktiv",
    "video_voting.intro_text": "Dieses Video enthält Zuschauerfragen, an denen du dich beteiligen kannst. Du kannst diese Funktion deaktivieren, anonym abstimmen und einzelne Fragen überspringen. Über die ",
    "video_voting.join_discussion": "Beteilige Dich am Gespräch",
    "video_voting.manage_voting_admin": "Abstimmungen verwalten (Admin)",
    "video_voting.no_data_available": "Keine Abstimmungsdaten vorhanden",
    "video_voting.no_main_screen": "Kein Hauptbildschirm für Videoabstimmung definiert.",
    "video_voting.no_question_overlay": "Kein Frage-Overlay angezeigt",
    "video_voting.no_space_selected": "Wählen Sie vor dem Speichern einen Bereich für diese Abstimmung aus.",
    "video_voting.not_logged_in_text": "Du musst angemeldet sein, um diese Funktion nutzen zu können.\nDas Video wird wie gewohnt abgespielt und du siehst keine Abstimmungen.\n**Klicke hier, um dich einzuloggen**.",
    "video_voting.preview_admin": "Vorschau Videoabstimmung (Admin)",
    "video_voting.select_voting_for_article": "Wähle eine Abstimmung für diesen Artikel",
    "video_voting.settings": "Einstellungen",
    "video_voting.start_video": "Video starten",
    "video_voting.template_missing": "Das Video-Voting-Vorlage fehlt",
    "video_voting.time": "Zeit:",
    "video_voting.title": "Video Voting",
    "video_voting.vote_anonymously": "Anonymisiert abstimmen",
    "video_voting.votings_tab": "Abstimmungen",
    "video_voting.waiting_for_video": "Warten auf das Laden des Videos!",
    "videoplayer_demo.pause": "PAUSE",
    "videoplayer_demo.play": "ABSPIELEN",
    "videoplayer_demo.seek_60": "ZU 60 SEKUNDEN SPRINGEN",
    "videovoting.select_chapter": "Wählen Sie ein Kapitel aus",
    "videovoting.select_existing_voting": "Wählen Sie eine bestehende Videoabstimmung aus",
    "videovoting.select_question": "Wählen Sie eine Frage aus",
    "visibility.only_visible_to_admins": "Nur für Admins sichtbar",
    "vote.delete_button": "Löschen",
    "vote.delete_modal_heading": "Sind Sie sicher, dass Sie Ihre Stimme löschen möchten?",
    "vote.delete_modal_warning": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "voting.no": "Nein",
    "voting.yes": "Ja",
    "zdf_admin.votings": "Abstimmungen",
    "zdf_channels.all_channels_roles_access": "Eigentümer und Redakteure haben Zugriff auf diesen Kanal.",
    "zdf_channels.channel_name_error": "Geben Sie einen Kanalnamen ein.",
    "zdf_channels.default_channel_explanation": "Alle Admin-Benutzer haben Zugriff auf den Standardkanal.\n\nNeue Fragen, die keinem bestimmten Kanal zugewiesen sind, werden dem Standardkanal zugewiesen.\n\nEs kann nur einen Standardkanal geben.",
    "zdf_channels.image_url_error": "Geben Sie eine vollständige Bild-URL ein, die mit https:// beginnt.",
    "zdf_videovoting.no_session": "**Keine Sitzung initialisiert**",
    "zdf_videovoting.poll_type": "Umfrage",
    "zdf_videovoting.slider_type": "Schieberegler",
    "zdf_videovoting_editor.add_chapter": "Kapitel hinzufügen",
    "zdf_videovoting_editor.add_option": "Option hinzufügen",
    "zdf_videovoting_editor.add_predetermined_answer": "Eine vorbestimmte Antwort hinzufügen",
    "zdf_videovoting_editor.add_question": "Frage hinzufügen",
    "zdf_videovoting_editor.answer_label": "Antwortbeschriftung",
    "zdf_videovoting_editor.answer_value": "Antwortwert",
    "zdf_videovoting_editor.assign_chapter": "Ein Kapitel zuweisen",
    "zdf_videovoting_editor.assign_space": "Einen Raum zuweisen",
    "zdf_videovoting_editor.chapters": "Kapitel:",
    "zdf_videovoting_editor.layout": "Layout:",
    "zdf_videovoting_editor.maximum_value": "Höchstwert",
    "zdf_videovoting_editor.minimum_value": "Mindestwert",
    "zdf_videovoting_editor.name": "Name",
    "zdf_videovoting_editor.open_preview": "Vorschau öffnen (Debug)",
    "zdf_videovoting_editor.options": "Optionen",
    "zdf_videovoting_editor.prefill_data": "Daten aus bestehender Abstimmung vorausfüllen",
    "zdf_videovoting_editor.question_name": "Fragenname",
    "zdf_videovoting_editor.question_type": "Fragetyp",
    "zdf_videovoting_editor.questions": "Fragen:",
    "zdf_videovoting_editor.remove_chapter": "Kapitel entfernen",
    "zdf_videovoting_editor.selected_chapter": "Ausgewähltes Kapitel:",
    "zdf_videovoting_editor.selected_space": "Ausgewählter Raum:",
    "zdf_videovoting_editor.slider_answers": "Schieberegler-Antworten",
    "zdf_videovoting_editor.slider_options": "Schieberegler-Optionen",
    "zdf_videovoting_editor.stops_video": "Video stoppen",
    "zdf_videovoting_editor.timestamp": "Zeitstempel",
    "zdf_videovoting_editor.unit": "Einheit",
    "zdf_videovoting_editor.video_info": "Video-Info:",
    "zdf_videovoting_editor.voting_title": "Abstimmungstitel",
    "{count} {noun}": "{count} {noun}"
}
